import { HuiPage } from "hireart-components";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";

import { Button, Dimmer, Grid, Loader } from "semantic-ui-react";
import { Toasts } from "common/components/Toasts";
import CalendarMutation from "../../../Managers/Hiring/mutations/UpdateCalendarMutation";
import CalendarQuery from "../../../Managers/Hiring/queries/CalendarQuery";
import AppointmentSlots from "./AppointmentSlots";
import AvailabilityBufferModal from "./AvailabilityBufferModal";
import CalendarBase from "./CalendarBase";
import InterviewsUpcoming from "./InterviewsUpcoming";
import GoogleCalendarDisconnectModal from "./modals/GoogleCalendarDisconnectModal";
import RequestsOutstanding from "./RequestsOutstanding";

import "common/css/calendarValidations.css";
import "common/css/calendar.css";
import "./css/Editor.scss";

export class CalendarEditor extends CalendarBase {
  constructor(props) {
    super(props);
    this.submitCalendar = this.submitCalendar.bind(this);
  }

  afterSubmit(message) {
    Toasts.success(message || "Calendar updated");
  }

  pageTitle = () => {
    const {
      data: { loading, calendar },
      user,
    } = this.props;

    if (loading) {
      return "...";
    }
    if (calendar?.google_synced && !user?.usesCronofyFeatures) {
      return "Manage my availability";
    }
    return "Interview calendar";
  };

  subDescription = () => {
    const {
      data: { loading, calendar },
      user,
    } = this.props;

    if (loading) {
      return "...";
    }
    if (calendar?.google_synced) {
      return "View availability synced from your Google Calendar";
    }
    if (user?.usesCronofyFeatures) {
      return "View your list of upcoming and pending interviews";
    }
    return "Click to add/remove timeslots available to candidates for interviews.";
  };

  render() {
    const {
      data: { loading, calendar },
      user,
    } = this.props;

    return (
      <HuiPage title={this.pageTitle()} description={this.subDescription()}>
        <div className="custom-fluid-container">
          <Prompt
            when={this.didUpdateAppSlots()}
            message="You have unsaved changes to your appointment slots. Are you sure you want leave?"
          />
          {!user?.usesCronofyFeatures && (
            <div className="rounded-4 divide-y divide-neutral-20 overflow-hidden border border-neutral-20 bg-neutral-10">
              <div className="calendar is-full" style={{ padding: 0 }}>
                <Dimmer inverted active={loading}>
                  <Loader />
                </Dimmer>
                <div
                  style={{
                    transition: "opacity 0.2s ease-out",
                    opacity: loading ? 0.0 : 1.0,
                  }}
                >
                  <AppointmentSlots
                    appointmentSlots={this.state.mergedAppSlots}
                    createSlots={this.createAppSlots}
                    removeSlots={this.removeAppSlots}
                    slotSizeMinutes={this.appSlotIntervalMinutes}
                    timeZone={this.timeZone}
                    timeZoneSelect={this.timeZoneSelect}
                    bufferTimeSelect={this.bufferTimeSelect}
                    calendar={calendar}
                    cta={calendar && this.ctaComponent.bind(this, calendar)}
                  />
                  <AvailabilityBufferModal />
                  {calendar && (
                    <GoogleCalendarDisconnectModal
                      calendar={calendar}
                      open={this.state.showGoogleDisconnectModal}
                      onClose={() =>
                        this.setState({ showGoogleDisconnectModal: false })
                      }
                    />
                  )}
                </div>
              </div>
              <div style={{ padding: "15px 20px 20px" }}>
                <Grid columns={2} id="calendar-actions">
                  <Grid.Row>
                    <Grid.Column width={16}>
                      {!loading && this.availabilityDetails()}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    {!loading && !calendar.google_synced && (
                      <>
                        <Grid.Column width={12}>
                          {this.userFeedback()}
                        </Grid.Column>
                        <Grid.Column floated="right" width={4}>
                          <Button
                            onClick={this.submitCalendar}
                            loading={this.state.submitting}
                            disabled={
                              !this.didUpdateAppSlots() || !!this.hasError()
                            }
                            size="large"
                            primary
                            fluid
                          >
                            Save
                          </Button>
                        </Grid.Column>
                      </>
                    )}
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          )}

          {!loading && (
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <InterviewsUpcoming
                    interviewRequests={calendar.interview_requests}
                  />
                </Grid.Column>
                <Grid.Column>
                  <RequestsOutstanding
                    interviewRequests={calendar.interview_requests}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </div>
      </HuiPage>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

export default CalendarMutation(
  CalendarQuery(connect(mapStateToProps)(CalendarEditor))
);
